export const club = {
  // Common
  clubs: "俱乐部",
  club: "俱乐部",
  city: "城市",
  members: "成员",
  member: "成员",
  wins: "胜",
  losses: "负",
  draws: "平",
  record: "战绩",
  invite: "邀请",
  inviteCode: "邀请码",
  copyLink: "复制链接",
  inviteLinkCopied: "邀请链接已复制！",

  list: {
    title: "俱乐部",
    subtitle: "你所在的网球社群。",
    myClubs: "我的俱乐部",
    clubsInCity: "{{city}}的俱乐部",
    create: "创建俱乐部",
    join: "加入",
    joinCodePlaceholder: "邀请码",
    empty: "你还没有加入任何俱乐部。",
    emptyHint: "向俱乐部组织者要邀请码，或者自己创建一个。",
  },

  new: {
    title: "新建俱乐部",
    subtitle: "为你的城市创建一个网球社群。",
    name: "俱乐部名称",
    namePlaceholder: "例如：多伦多华人网球俱乐部",
    country: "国家",
    city: "城市",
    selectCity: "选择城市",
    bio: "简介（可选）",
    bioPlaceholder: "成员在俱乐部主页看到的简短介绍。",
    logo: "Logo",
    logoHint: "（可选，最大 2MB）",
    chooseImage: "选择图片",
    changeImage: "更换图片",
    remove: "删除",
    create: "创建俱乐部",
    creating: "创建中...",
    footnote: "创建后会生成邀请码，分享给成员后他们可以加入。",
  },

  detail: {
    activities: "俱乐部活动",
    members: "成员",
    showingFirst: "显示前 {{shown}} / 共 {{total}}",
    owner: "管理员",
    leave: "退出俱乐部",
    delete: "删除俱乐部",
    confirmLeave: "确定要退出 {{name}}？",
    confirmDelete: "删除 {{name}}？此操作无法撤销。",
    inviteHint: "把邀请码或链接分享给你想邀请的人。",
  },

  join: {
    invitedTo: "你被邀请加入",
    joinClub: "加入俱乐部",
    joining: "加入中...",
    alreadyMember: "你已是成员 — 查看俱乐部",
    maybeLater: "稍后再说",
    cantJoin: "无法加入",
    invalidCode: "邀请链接无效",
  },
};

export const clubMatch = {
  title: "俱乐部对抗赛",
  titlePlural: "俱乐部对抗赛",

  list: {
    empty: "还没有对抗赛。",
    emptyOwner: "还没有对抗赛。挑战其他俱乐部！",
    challenge: "+ 发起挑战",
    vsLabel: "vs",
  },

  status: {
    home_signup_open: "主队内部报名",
    pending_acceptance: "等待对手回应",
    rejected: "已拒绝",
    away_signup_open: "客队内部报名",
    scheduled: "已确认",
    in_progress: "进行中",
    completed: "已完成",
    cancelled: "已取消",
  },

  new: {
    title: "新建对抗赛",
    subtitle: "设置赛制、完成主队报名，然后发起挑战。",
    yourClub: "你的俱乐部",
    opponent: "对手俱乐部",
    opponentCodeHint: "对手的邀请码",
    find: "查找",
    change: "更换",
    date: "比赛日期",
    location: "地点（可选）",
    locationPlaceholder: "例如：Royal York Tennis Club",
    message: "留言（可选）",
    messagePlaceholder: "给对手 owner 的留言。",
    composition: "赛制设置",
    addSlot: "+ 加一场",
    matchNum: "第 {{num}} 场",
    bestOf: "{{n}} 盘三胜",
    oneSet: "1 盘制",
    create: "创建并开放报名",
    creating: "创建中...",
    footnote:
      "{{home}} 的成员可以报名参赛。Owner 选定阵容后，发起挑战给 {{away}}。",
    notOwnerTitle: "只有俱乐部 owner 才能发起对抗赛",
    notOwnerBody: "先创建一个俱乐部，或请 owner 发起挑战。",
    errors: {
      pickClub: "请选择你的俱乐部",
      pickOpponent: "请选择对手俱乐部",
      noOpponent: "找不到此邀请码对应的俱乐部",
      ownClub: "不能挑战自己的俱乐部",
      pickDate: "请选择比赛日期",
      addSlot: "至少添加一场比赛",
    },
  },

  detail: {
    sendChallenge: "发起挑战",
    pickHomeFirst: "请先选定主队全部阵容",
    pickAwayFirst: "请先选定客队全部阵容",
    accept: "接受挑战",
    reject: "拒绝",
    confirmLineup: "确认阵容",
    cancelMatch: "取消对抗赛",
    confirmCancel: "确定要取消这场对抗赛？",
    recordScore: "录入比分",
    iWillPlay: "我要打",
    withdraw: "退出",
    pickPlayer: "选择球员",
    pickDoubles: "选择双打搭档",
    waitingForSignups: "等待成员报名",
    signedUpCount: "{{n}} 人已报名",
    matchHeader: "第 {{slot}} 场 · {{category}} · {{bestOf}} 盘制",
    wonLabel: "{{name}} 胜",
    pickerTitle: "选择球员",
    pickerTitleDoubles: "选择双打组合",
    pickerHint: "从报名名单中点选最多 {{needed}} 人。",
    pickerEmpty: "还没有人报名。让成员去报名。",
    confirm: "确认 ({{selected}}/{{needed}})",
    pickExactly: "请正好选择 {{n}} {{noun}}。",
    scoreModalTitle: "录入比分",
    scoreModalSubtitle: "第 {{slot}} 场 · {{bestOf}} 盘制",
    setLabel: "第 {{n}} 盘",
    enterScores: "请输入比分直到分出胜负",
    champion: "冠军",
    draw: "平局",
  },

  categories: {
    mens_singles: "男单",
    womens_singles: "女单",
    mens_doubles: "男双",
    womens_doubles: "女双",
    mixed_doubles: "混双",
  },
};
